import FilterService from "./FilterService";
import FetchService from "./FetchService";
const baseURL = "/aviso/person/";
/**
 * Maps a JSON object from the server into a Person model object instance.
 *
 * @param {object} jsonObject - A JSON object from the server.
 */
function mapJsonToPerson(jsonObject) {
    return {
        firstName: jsonObject.firstName,
        lastName: jsonObject.lastName,
        personId: jsonObject.personId,
        affiliationId: jsonObject.affiliationId,
        fullName: jsonObject.fullName,
        smallPhotoUrl: jsonObject.smallPhotoUrl,
        studentId: jsonObject.studentId,
        emailAddress: jsonObject.emailAddress,
        initialsBackgroundColorHex: jsonObject.initialsBackgroundColorHex,
    };
}
function fetchPersonInternal(params) {
    let paramName = "personId"; // Initialize just in case.
    let paramValue;
    if (params.personId) {
        paramValue = params.personId;
    }
    else if (params.affiliationId) {
        paramName = "affiliationId";
        paramValue = params.affiliationId;
    }
    return FetchService.get(baseURL + "getPerson", {
        [paramName]: paramValue,
    }).then(mapJsonToPerson);
}
export default class PersonService {
    /**
     * Fetches a person record.
     *
     * @param {string} personId - The ID of the person to fetch.
     */
    static fetchPerson(personId) {
        return fetchPersonInternal({ personId });
    }
    /**
     * Fetches a person record.
     *
     * @param {string} affiliationId - The affiliation ID of the person to fetch.
     */
    static fetchPersonByAffiliationId(affiliationId) {
        return fetchPersonInternal({ affiliationId });
    }
    /**
     * Retrieves the currently logged in user's Person record.
     */
    static me() {
        return FetchService.getSingleResponse(baseURL + "me").then(mapJsonToPerson);
    }
    /**
     * Returns a list of people that match the query
     * *(all params defaulted because endpoint will fail unless all values are provided)*
     *
     * @param {string} [query=''] - the query string
     * @param {boolean} [onlyStudents=false] - whether or not to only search current students
     * @param {number} [max=50] - the max number of results
     * @param {number} [offset=0] - the offset of the results (used for paging)
     */
    static listAsJson(query = "", onlyStudents = false, max = 50, offset = 0) {
        return FetchService.get(baseURL + "listAsJson", {
            query,
            onlyStudents,
            max,
            offset,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((response) => response.map(mapJsonToPerson));
    }
    static findAllByIds(personIds) {
        return FetchService.get(`${baseURL}findAllByIds?ids=${personIds.join(",")}`).then((response) => response.data.map(mapJsonToPerson));
    }
    /**
     * Search for people using the allStudents filter
     *
     * @param {string} query - the query string to use in the filter
     * @param {number} [maxPeople=50] - the max number of people to return
     */
    static searchUsingFilter(query, maxPeople = 50) {
        return FilterService.getAllStudentsFilterId().then((filterId) => FetchService.getPagedResponse("/aviso/advisor/getStudentList", {
            filterId,
            q: query,
            maxRows: maxPeople,
        }));
    }
}
